document.addEventListener("DOMContentLoaded", function () {

    const popup = document.getElementById("dc-popup");

    const closeBtn = document.querySelector(".dc-close");

    if (!popup) return;

    // Show popup after 5 seconds
    if (!localStorage.getItem("dcPopupClosed")) {

        setTimeout(function () {

            popup.classList.add("show");

        }, 5000);

    }

    // Close button
    if (closeBtn) {
        closeBtn.addEventListener("click", function () {

            popup.classList.remove("show");

            localStorage.setItem("dcPopupClosed", "yes");

        });
    }

    // Click outside popup
    popup.addEventListener("click", function (e) {

        if (e.target === popup) {

            popup.classList.remove("show");

            localStorage.setItem("dcPopupClosed", "yes");

        }

    });

    // ESC key
    document.addEventListener("keydown", function (e) {

        if (e.key === "Escape") {

            popup.classList.remove("show");

            localStorage.setItem("dcPopupClosed", "yes");

        }

    });

});